<template>
  <div class="StatisticsTable">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div style="width:100vw">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">自主檢驗超時</span>
              </b-col>

              <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                <b-row>
                  <commonQueryIoT />
                </b-row>
              </b-col>

              <b-col cols="12" style="margin-top: 2rem">
                <template v-if="queryStatus == true">
                  <inspectTimeoutData />
                </template>
              </b-col>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import inspectTimeoutData from "@/components/inspectTimeoutData.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "StatisticsTable",
  data() {
    return {
      queryStatus: false
    };
  },
  created: function() {
    this.change_selectPage("statisticstable");
    this.change_selectPageName(this.pageName.statisticstable);
    this.setCommonQueryData();
    this.setQueryInput();
    this.set_plugInPage("inspectTimeout");
  },
  mounted: function() {
    let vm = this;
  },
  components: {
    commonQueryIoT,
    inspectTimeoutData
  },
  watch: {
    mainQueryResponse: {
      handler() {
        let vm = this;
        //更新資料，初始化資料
        vm.reset([]);
        vm.set_inspectTimeoutDataItem([]);
        vm.set_device_total_qty(0);
        vm.set_batch_total_qty(0);
        vm.set_inspect_total_qty(0);
        vm.set_timeout_total_qty(0);
        vm.set_inspectTimeoutDetailData([]);
        vm.set_inspectTimeoutShowDetail(false);
        vm.set_inspectFactory("");

        if (typeof vm.mainQueryResponse === "string") {
          return;
        }
        vm.set_inspectTimeoutDataItem(
          vm.mainQueryResponse["inspectTimeoutDataItem"]
        );
        vm.set_device_total_qty(vm.mainQueryResponse["device_total_qty"]);
        vm.set_batch_total_qty(vm.mainQueryResponse["batch_total_qty"]);
        vm.set_inspect_total_qty(vm.mainQueryResponse["inspect_total_qty"]);
        vm.set_timeout_total_qty(vm.mainQueryResponse["timeout_total_qty"]);
        vm.set_inspectTimeoutDetailData(
          vm.mainQueryResponse["inspectTimeoutDetailData"]
        );
        vm.set_inspectFactory(vm.mainQueryResponse["factory"]);
        vm.queryStatus = true;
        console.log(vm.mainQueryResponse);
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      previousPage: "previousPage/get_previousPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_plugInPage: "commonqueryiot/set_plugInPage",
      set_inspectTimeoutDataItem:
        "inspectTimeoutData/set_inspectTimeoutDataItem",
      set_device_total_qty: "inspectTimeoutData/set_device_total_qty",
      set_batch_total_qty: "inspectTimeoutData/set_batch_total_qty",
      set_inspect_total_qty: "inspectTimeoutData/set_inspect_total_qty",
      set_timeout_total_qty: "inspectTimeoutData/set_timeout_total_qty",
      set_inspectTimeoutDetailData:
        "inspectTimeoutData/set_inspectTimeoutDetailData",
      set_inspectTimeoutShowDetail:
        "inspectTimeoutData/set_inspectTimeoutShowDetail",
      set_inspectFactory: "inspectTimeoutDetailData/set_inspectFactory"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("query_inspect_timeout");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        inspProcess: true,
        group: true
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: true,
        inspProcess: true,
        group: true
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    this.set_plugInPage("");
    this.set_inspectTimeoutDataItem([]);
    this.set_device_total_qty(0);
    this.set_batch_total_qty(0);
    this.set_inspect_total_qty(0);
    this.set_timeout_total_qty(0);
    this.set_inspectTimeoutDetailData([]);
    this.set_inspectTimeoutShowDetail(false);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/inspectTimeout.vue